// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { fileSchema } from '@/file/api/types';
import { z } from 'zod';

const fulfillmentFilesResponseSchema = z.object({
  data: z.array(fileSchema),
  metadata: responseMetadataSchema,
});

/**
 * Requests a collection of files for a fulfillment order from the remote API.
 *
 * @param key - The key of the fulfillment order for which to request files.
 */
export async function getFulfillmentFiles(key: string) {
  const path = `/v1/fulfillment/${key}/file`;
  const response = await api.get(path);

  return parseResponse(fulfillmentFilesResponseSchema, response.data, {
    schemaName: 'FulfillmentFiles',
    endpoint: path,
  });
}
